import * as React from "react";
import type { SVGProps } from "react";
const SvgSwimmingPool = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 13a1 1 0 0 1-1-1v-1h-4v1a1 1 0 1 1-2 0V4.5A2.5 2.5 0 0 1 10.5 2a1 1 0 1 1 0 2 .5.5 0 0 0-.5.5V5h4v-.5A2.5 2.5 0 0 1 16.5 2a1 1 0 1 1 0 2 .5.5 0 0 0-.5.5V12a1 1 0 0 1-1 1m-5-4h4V7h-4z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M19.91 18h.14a3.39 3.39 0 0 0 2.78-1.42 1 1 0 0 0-.23-1.39 1 1 0 0 0-1.39.23A1.54 1.54 0 0 1 20 16a1.39 1.39 0 0 1-1.21-.58A3.41 3.41 0 0 0 16 14a3.51 3.51 0 0 0-2.79 1.42A1.52 1.52 0 0 1 12 16a1.42 1.42 0 0 1-1.21-.58A3.41 3.41 0 0 0 8 14a3.5 3.5 0 0 0-2.79 1.42A1.54 1.54 0 0 1 4 16a1.39 1.39 0 0 1-1.17-.58 1 1 0 0 0-1.39-.23 1 1 0 0 0-.23 1.39A3.38 3.38 0 0 0 4 18a3.38 3.38 0 0 0 2.79-1.42A1.41 1.41 0 0 1 8 16a1.47 1.47 0 0 1 1.21.58A3.4 3.4 0 0 0 12 18a3.36 3.36 0 0 0 2.79-1.42A1.4 1.4 0 0 1 16 16a1.49 1.49 0 0 1 1.19.58A3.38 3.38 0 0 0 19.91 18"
    />
    <path
      fill="currentColor"
      d="M19.91 22h.14a3.39 3.39 0 0 0 2.78-1.42 1 1 0 0 0-.23-1.39 1 1 0 0 0-1.39.23A1.54 1.54 0 0 1 20 20a1.39 1.39 0 0 1-1.21-.58A3.49 3.49 0 0 0 16 18a3.54 3.54 0 0 0-2.79 1.42A1.52 1.52 0 0 1 12 20a1.42 1.42 0 0 1-1.21-.58A3.49 3.49 0 0 0 8 18a3.52 3.52 0 0 0-2.79 1.42A1.54 1.54 0 0 1 4 20a1.39 1.39 0 0 1-1.17-.58 1 1 0 0 0-1.39-.23 1 1 0 0 0-.23 1.39A3.38 3.38 0 0 0 4 22a3.46 3.46 0 0 0 2.79-1.42A1.41 1.41 0 0 1 8 20a1.47 1.47 0 0 1 1.21.58A3.4 3.4 0 0 0 12 22a3.44 3.44 0 0 0 2.79-1.42A1.4 1.4 0 0 1 16 20a1.49 1.49 0 0 1 1.19.58A3.38 3.38 0 0 0 19.91 22"
    />
  </svg>
);
export default SvgSwimmingPool;
